var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lite-website myscroll" },
    [
      _c("div", { staticClass: "lite-website-content" }, [
        _c("div", { staticClass: "website_title" }, [
          _c("div", { staticClass: "website_title_main" }, [
            _vm._v(_vm._s(_vm.$t("language.website.title")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "website_title_desc" }, [
            _vm._v(_vm._s(_vm.$t("language.website.desc")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "website_switch" }, [
          _c(
            "div",
            {
              staticClass: "website_switch_item",
              class: _vm.isClone ? "" : "website_switch_select",
              on: {
                click: function($event) {
                  return _vm.switchTaskType("backup")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.leftBanner.liteWebsite")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "website_switch_item",
              class: _vm.isClone ? "website_switch_select" : "",
              on: {
                click: function($event) {
                  return _vm.switchTaskType("clone")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.leftBanner.liteClone")))]
          )
        ]),
        _vm._v(" "),
        !_vm.isClone
          ? _c("div", { staticClass: "website_backup" }, [
              _c("div", { staticClass: "website_from_to" }, [
                _c(
                  "div",
                  {
                    staticClass: "backup_from_to",
                    class: _vm.boxFrom,
                    on: {
                      click: function($event) {
                        _vm.$refs.backupFromTree.show = true
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "backup_from_to_content" }, [
                      _c(
                        "div",
                        { staticClass: "backup_from_to_content_title" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("language.website.siteFromTitle"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "backup_from_to_content_desc" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("language.website.siteFromDesc"))
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("liteSelectView", {
                      staticClass: "backup_from_select",
                      attrs: { arrData: _vm.liteSelectFromData }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "backup_center" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "backup_from_to",
                    class: _vm.boxTo,
                    on: {
                      click: function($event) {
                        _vm.$refs.websiteToTree.show = true
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "backup_from_to_content" }, [
                      _c(
                        "div",
                        { staticClass: "backup_from_to_content_title" },
                        [_vm._v(_vm._s(_vm.$t("language.website.siteToTitle")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "backup_from_to_content_desc" },
                        [_vm._v(_vm._s(_vm.$t("language.website.siteToDesc")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("liteSelectView", {
                      staticClass: "backup_to_select",
                      attrs: { data: _vm.liteSelectToData }
                    })
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isClone
          ? _c("div", { staticClass: "website_clone" }, [
              _c("div", { staticClass: "website_from_to" }, [
                _c(
                  "div",
                  { staticClass: "clone_from_to", class: _vm.boxFrom },
                  [
                    _c("div", { staticClass: "clone_head" }, [
                      _c("div", { staticClass: "clone_head_title" }, [
                        _vm._v(_vm._s(_vm.$t("language.cloudTransfer.from")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "add_website_row",
                        class: _vm.websiteTips ? "showTips" : "",
                        on: {
                          click: function($event) {
                            return _vm.readyAddWebsite()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("language.common.addWebsite")))
                        ]),
                        _vm._v(" "),
                        _vm.websiteTips
                          ? _c(
                              "div",
                              {
                                staticClass: "lite_my_tips",
                                attrs: { "data-language": _vm.$i18n.locale },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.donot()
                                  }
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "lite_my_tips_triangle"
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "lite_my_tips_close icon-util bubble-close",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.hideAddWebsiteTips()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "lite_my_tips_text" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.common.websiteTip")
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "lite_my_tips_btn" }, [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.hideAddWebsiteTips()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("language.common.ok"))
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "clone_body myscroll" },
                      _vm._l(_vm.websites, function(website) {
                        return _c(
                          "div",
                          { key: website.id, staticClass: "website_item" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "website_item_box",
                                on: {
                                  click: function($event) {
                                    return _vm.loadWebsiteChilds(
                                      website,
                                      "from"
                                    )
                                  }
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "website_item_status",
                                  class: {
                                    clone_tree_open: website.isOpen,
                                    clone_tree_close: !website.isOpen,
                                    clone_tree_loading:
                                      website.isLoadingChilds &&
                                      _vm.isLoadingChildsWay == "from"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "website_item_icon clone_website"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "website_item_name" },
                                  [_vm._v(_vm._s(website.name))]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "website_item_delete clone_delete",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showDelConfirm(website)
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            website.isOpen &&
                            website.childs &&
                            website.childs.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "website_item_childs" },
                                  _vm._l(website.childs, function(node) {
                                    return _c(
                                      "div",
                                      {
                                        key: node.id,
                                        staticClass: "website_item_child",
                                        on: {
                                          click: function($event) {
                                            return _vm.selectNode("from", node)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "website_item_status",
                                          class:
                                            _vm.cloneLeftSelect == node.id
                                              ? "clone_radio_select"
                                              : "clone_radio_blank"
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "website_item_icon",
                                          class: "clone_" + node.type
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "website_item_name" },
                                          [_vm._v(_vm._s(node.name))]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clone_split" }),
                _vm._v(" "),
                _c("div", { staticClass: "clone_center" }, [
                  _c("div", { staticClass: "clone_head" }, [
                    _c("div", { staticClass: "center_left_right" }, [
                      _c("div", { staticClass: "center_left" }, [
                        _c("div", { staticClass: "clone_head_title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.website.sourceServers"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "center_right" }, [
                        _c("div", { staticClass: "clone_head_title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.website.targetServers"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "clone_head_icon clone_delete",
                          on: {
                            click: function($event) {
                              return _vm.cleanCloneSelect()
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clone_body myscroll" }, [
                    _c("div", { staticClass: "center_left_right" }, [
                      _c(
                        "div",
                        { staticClass: "center_left" },
                        _vm._l(_vm.cloneFromData, function(node, index) {
                          return _c(
                            "div",
                            { staticClass: "clone_select_item" },
                            [
                              _c("div", {
                                staticClass: "clone_select_item_icon",
                                class: "clone_" + node.type
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "clone_select_item_name",
                                  attrs: { title: _vm.getDrive(node.did).name }
                                },
                                [_vm._v(_vm._s(node.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "clone_select_item_delete" },
                                [
                                  _c("div", {
                                    staticClass: "clone_delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteSelectItem(index)
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "center_right" },
                        _vm._l(_vm.cloneToData, function(node, index) {
                          return _c(
                            "div",
                            { staticClass: "clone_select_item" },
                            [
                              _c("div", {
                                staticClass: "clone_select_item_icon",
                                class: "clone_" + node.type
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "clone_select_item_name",
                                  attrs: { title: _vm.getDrive(node.did).name }
                                },
                                [_vm._v(_vm._s(node.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "clone_select_item_delete" },
                                [
                                  _c("div", {
                                    staticClass: "clone_delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteSelectItem(index)
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clone_split" }),
                _vm._v(" "),
                _c("div", { staticClass: "clone_from_to", class: _vm.boxTo }, [
                  _c("div", { staticClass: "clone_head" }, [
                    _c("div", { staticClass: "clone_head_title" }, [
                      _vm._v(_vm._s(_vm.$t("language.cloudTransfer.to")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "add_website_row",
                      on: {
                        click: function($event) {
                          return _vm.readyAddWebsite()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("language.common.addWebsite")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "clone_body myscroll" },
                    _vm._l(_vm.websites, function(website) {
                      return _c(
                        "div",
                        { key: website.id, staticClass: "website_item" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "website_item_box",
                              on: {
                                click: function($event) {
                                  return _vm.loadWebsiteChilds(website, "to")
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "website_item_status",
                                class: {
                                  clone_tree_open: website.isOpen2,
                                  clone_tree_close: !website.isOpen2,
                                  clone_tree_loading:
                                    website.isLoadingChilds &&
                                    _vm.isLoadingChildsWay == "to"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "website_item_icon clone_website"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "website_item_name" }, [
                                _vm._v(_vm._s(website.name))
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "website_item_delete clone_delete",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showDelConfirm(website)
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          website.isOpen2 &&
                          website.childs &&
                          website.childs.length > 0
                            ? _c(
                                "div",
                                { staticClass: "website_item_childs" },
                                _vm._l(website.childs, function(node) {
                                  return _c(
                                    "div",
                                    {
                                      key: node.id,
                                      staticClass: "website_item_child",
                                      on: {
                                        click: function($event) {
                                          return _vm.selectNode("to", node)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "website_item_status",
                                        class:
                                          _vm.cloneRightSelect == node.id
                                            ? "clone_radio_select"
                                            : "clone_radio_blank"
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "website_item_icon",
                                        class: "clone_" + node.type
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "website_item_name" },
                                        [_vm._v(_vm._s(node.name))]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "website_bottom" },
          [
            _c(
              "div",
              {
                staticClass: "website_options",
                on: {
                  click: function($event) {
                    return _vm.openOptionsDialog()
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "website_options_icon clone_options"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "website_options_text" }, [
                  _vm._v(_vm._s(_vm.$t("language.common.options")))
                ])
              ]
            ),
            _vm._v(" "),
            !_vm.isClone
              ? _c(
                  "div",
                  {
                    staticClass: "website_schedule",
                    on: {
                      click: function($event) {
                        return _vm.openSchduleDialog()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "website_schedule_icon",
                      class: _vm.checkedSchedule
                        ? "clone_check_box_select"
                        : "clone_check_box_blank",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.checkedOpen()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "website_schedule_text" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.schedule")))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "website_task_name" }, [
              _c("div", { staticClass: "website_task_name_icon clone_edit" }),
              _vm._v(" "),
              !_vm.isEditName
                ? _c(
                    "div",
                    {
                      staticClass: "website_task_name_text",
                      on: {
                        click: function($event) {
                          return _vm.startEditTaskName()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.taskName))]
                  )
                : _c("div", { staticClass: "website_task_name_edit" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.taskName,
                          expression: "taskName"
                        }
                      ],
                      ref: "taskNameInput",
                      attrs: { type: "text" },
                      domProps: { value: _vm.taskName },
                      on: {
                        blur: function($event) {
                          return _vm.okEditTaskName()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.taskName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util name-sure",
                      on: {
                        click: function($event) {
                          return _vm.okEditTaskName()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util name-cancel",
                      on: {
                        click: function($event) {
                          return _vm.cancelEditTaskName()
                        }
                      }
                    })
                  ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "website_task_create",
                on: {
                  click: function($event) {
                    return _vm.addTask(_vm.checkedSchedule && !_vm.isClone)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "website_task_create_icon",
                  class: _vm.isClone ? "liteClone" : "liteWebsite"
                }),
                _vm._v(" "),
                _c("div", { staticClass: "website_task_create_text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.checkedSchedule && !_vm.isClone
                        ? _vm.$t("language.cloudTransfer.addTaskOnly")
                        : _vm.isClone
                        ? _vm.$t("language.website.cloneNow")
                        : _vm.$t("language.cloudBackup.backupNow")
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.checkedSchedule && !_vm.isClone
                  ? _c("div", {
                      staticClass: "website_task_create_icon_right clone_down",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.showOnlyCreate = !_vm.showOnlyCreate
                        }
                      }
                    })
                  : _c("div", {
                      staticClass: "website_task_create_icon_right_blank"
                    })
              ]
            ),
            _vm._v(" "),
            _vm.checkedSchedule && !_vm.isClone && _vm.showOnlyCreate
              ? _c(
                  "div",
                  {
                    staticClass: "website_task_create_only",
                    on: {
                      click: function($event) {
                        return _vm.addTask(false)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isClone
                          ? _vm.$t("language.website.addTaskNow")
                          : _vm.$t("language.cloudTransfer.addBackupTaskNow")
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("transition", { attrs: { name: "flow" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.flowShow,
                      expression: "flowShow"
                    }
                  ],
                  staticClass: "flow-icon",
                  attrs: { id: "transferFlow" }
                },
                [
                  _c("div", {
                    staticClass:
                      "icon transfer-task-position cloudTransfer flow-icon-position"
                  })
                ]
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.websiteTips && _vm.isClone
          ? _c("div", {
              staticClass: "website_guide_overlay",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.donot()
                }
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-buttom" }),
      _vm._v(" "),
      _c("liteSelect", {
        ref: "websiteToTree",
        attrs: {
          showCheckbox: false,
          showDBDrive: false,
          showEmailDrive: false,
          showFileNode: false,
          showNewFolder: true
        },
        on: { selectDone: _vm.selectDoneTo }
      }),
      _vm._v(" "),
      _c("liteSelect", {
        ref: "backupFromTree",
        attrs: {
          showCheckbox: true,
          onlyWebsite: true,
          showFileNode: true,
          showNewFolder: false
        },
        on: { selectDone: _vm.selectDoneFrom }
      }),
      _vm._v(" "),
      _c("liteOptions", {
        ref: "websiteOptions",
        attrs: { data: _vm.liteOptionsData },
        on: { ok: _vm.okOptions }
      }),
      _vm._v(" "),
      _c("websiteScheduleDialog", { ref: "websiteScheduleDialog" }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.fullscreenLoading,
            expression: "fullscreenLoading"
          }
        ],
        staticClass: "lite-website-loading"
      }),
      _vm._v(" "),
      _c("liteAddDrive", {
        attrs: { auth: _vm.auth },
        on: {
          submit: function($event) {
            return _vm.addWebsite()
          }
        }
      }),
      _vm._v(" "),
      _c("liteConfirm", {
        ref: "delConfirm",
        attrs: {
          showCancel: true,
          autoClose: false,
          okText: _vm.$t("language.common.delete"),
          cancelText: _vm.$t("language.common.cancel"),
          data: _vm.del_confirm_data
        },
        on: { ok: _vm.confirmDelWebsite, cancel: _vm.cancelDelConfirm }
      }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22746154", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22746154","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_website.vue
// module id = null
// module chunks = 